
<template>
  <div class="icon-management" :style="'height:' + conHeight + 'px;'" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="menu-contain">
      <div class="menu" v-loading="taskLoading">
        <div class="top">
          <div style="display: flex;">
            <p class="top-title">任务包名称</p>
          </div>
          <div style="align-items: center;">
            <!-- <el-input
              v-model="page.taskTitle"
              @change="getTaskList(true)"
              placeholder="请输入任务包名称"
              class="search-input"
              clearable
            >
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input> -->
            <el-date-picker
              v-show="taskReleaseCycleWay === '按核算月'"
              class="search-input"
              v-model="page.accountMonthList"
              unlink-panels
              type="monthrange"
              value-format="yyyyMM"
              format="yyyy年MM月"
              range-separator="至"
              start-placeholder="开始月份"
              end-placeholder="结束月份"
              :picker-options="pickerOptions"
              @change="yearChange"
              placeholder="选择核算月">
            </el-date-picker>
          </div>
          <div
            v-for="(item, index) in taskList"
            :key="index"
            class="menu-item"
            :style="item.guid == pageII.taskMainGuid ? 'background:#e9eef3' : ''"
            @click="handleLeft(item)"
          >
            <span class="name">
              {{ item.taskTitleShort }}
            </span>
            <div class="list-state">
              <span :class="item.timeState == '已结束'?'finish':'ongoing'">{{item.timeState}}</span>
              <!-- <span class="ongoing" v-if="item.timeState == '未完成'">进行中</span>
              <span class="finish" v-else>已完成</span> -->
            </div>
          </div>
          <div class="no-task" v-if="taskList.length == 0">暂无数据</div>
          <el-pagination
            v-if="page.totalRows>10"
            background
            class="pt pb back-color-fff"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10,20]"
            :current-page="page.pageIndex"
            :page-size="page.pageSize"
            small
            layout="prev, pager, next"
            :total="page.totalRows"
          >
          </el-pagination>
        </div>
      </div>
      <div class="subject-table">
        <p class="subject-table-title" v-if="pageII.totalRows == 0">任务事项</p>
        <p class="subject-table-title" v-else>{{ taskTitle }}<span>共 {{pageII.totalRows}} 个，执行时间 {{startTime}} 至 {{endTime}}</span></p>
        <el-table :data="productInformationList" border stripe>
          <el-table-column label="序号" width="60" header-align="center" align="center">
            <template slot-scope="scope">
              {{ (pageII.pageIndex - 1) * pageII.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="taskContentName" label="任务名称" header-align="left" align="left" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="staffTaskNote" label="任务介绍" header-align="left" align="left" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="staffWorkNote" label="工作要求" header-align="left" align="left" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{getWork(scope.row.staffWorkNote)}}</span>
            </template>
          </el-table-column>
          <el-table-column  prop="realCount" label="实际量" header-align="right" align="right" show-overflow-tooltip width="70">
          </el-table-column>
          <el-table-column  prop="planCount" label="计划量" header-align="right" align="right" show-overflow-tooltip width="70">
            <template slot-scope="scope">
              <span>{{scope.row.isNotLimit==1?'不限量':scope.row.planCount}}</span>
            </template>
          </el-table-column>
          <el-table-column label="完成进度" header-align="center" align="center" show-overflow-tooltip width="100">
            <template slot-scope="scope">
              <!-- 0-30% -->
              <div class="table-progress" v-if="scope.row.finishRate < 31">
                <el-progress
                  type="circle"
                  :percentage="scope.row.finishRate>100?100:scope.row.finishRate"
                  :width="24"
                  :stroke-width="4"
                  :show-text="false"
                  color="#FF683B"
                ></el-progress>
                <span>{{scope.row.finishRate}}%</span>
              </div>
              <!-- 31-50 -->
              <div class="table-progress" v-if="scope.row.finishRate > 30&&scope.row.finishRate < 51">
                <el-progress
                  type="circle"
                  :percentage="scope.row.finishRate>100?100:scope.row.finishRate"
                  :width="24"
                  :stroke-width="4"
                  :show-text="false"
                  color="#FFBB3B"
                ></el-progress>
                <span>{{scope.row.finishRate}}%</span>
              </div>
              <!-- 61-80 -->
              <div class="table-progress" v-if="scope.row.finishRate > 50&&scope.row.finishRate < 81">
                <el-progress
                  type="circle"
                  :percentage="scope.row.finishRate>100?100:scope.row.finishRate"
                  :width="24"
                  :stroke-width="4"
                  :show-text="false"
                  color="#2C9CCE"
                ></el-progress>
                <span>{{scope.row.finishRate}}%</span>
              </div>
              <!-- 81-1000 -->
              <div class="table-progress" v-if="scope.row.finishRate > 80">
                <el-progress
                  type="circle"
                  :percentage="scope.row.finishRate>100?100:scope.row.finishRate"
                  :width="24"
                  :stroke-width="4"
                  :show-text="false"
                  color="#2CCE7D"
                ></el-progress>
                <span>{{scope.row.finishRate}}%</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="操作" header-align="center" align="center" width="170">
            <template slot-scope="scope">
              <!-- 数据标注：已整包提交或驳回待整改中→「查看」只读（整改走待整改列表「去整改」）；
                   仅首次标注（含已保存未提交）→「去完成」可编辑提交 -->
              <a class="txt-color" @click="toFinish(scope.row, 1)">{{ isSjbzViewOnly(scope.row) ? '查看' : '去完成' }} </a>
              <!-- SJBZ 标注行无"查看完成列表"入口（该入口属问卷类任务；标注行完成后由上方「查看」只读回看承接） -->
              <a v-if="scope.row.taskContentType != 'SJBZ'" class="txt-color" @click="toFinish(scope.row)">｜查看完成列表</a>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pt pb back-color-fff"
          background
          @size-change="handleSizeChange1"
          @current-change="handleCurrentChange1"
          :current-page="pageII.pageIndex"
          :page-size="pageII.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="pageII.totalRows"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
import recentDate from "@/uilt/recentDate";
import { ENV } from "@/api/apiRoute"
const pickerOptions = {
  shortcuts: [
    {
      text: '本月',
      onClick(picker) {
        picker.$emit('pick', [new Date(), new Date()]);
      },
    },
    {
      text: '今年至今',
      onClick(picker) {
        const end = new Date();
        const start = new Date(new Date().getFullYear(), 0);
        picker.$emit('pick', [start, end]);
      },
    },
    {
      text: '最近六个月',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setMonth(start.getMonth() - 6);
        picker.$emit('pick', [start, end]);
      },
    },
  ],
};
export default {
  data() {
    return {
      pickerOptions,
      /**当前点击(选中)左侧的item */
      curTaskItem: {},
      taskReleaseCycleWay:'按核算月',
      accountMonthArea:'',
      accountMonthAreaII:'',
      //左边查询任务包
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: localStorage.guid,
        taskTitle: '',
        onlyMyData:true,
        staffGuid: '',
        accountMonth:null,
        accountMonthList:[],
        taskContentType: ['WJDC','BHOTC','BHRX','BHSY', 'SJBZ'],
        notState: ["已失效","待派发","草稿中","待发布","待受理","已撤回"],
        years:null
      },
      taskList: [],
      taskTitle: '',
      startTime:'-',
      endTime:'-',
      taskLoading:false,
      tableData: [],
      timeState: '',
      pageII: {
        tenantGuid: localStorage.guid,
        pageIndex:1,
        pageSize: 10,
        taskMainGuid: '',
        staffGuid: '',
        taskContentType: ['WJDC','BHOTC','BHRX','BHSY', 'SJBZ'],
        totalRows: 0,
        totalPage: 0,
      },
      productInformationList: [],
      conHeight: window.innerHeight - 85,
      fullscreenLoading: false,
      currentIndex: 0,
      value3:''
    };
  },
  created() {
    // if(this.$route.query.accountMonthList){
    //   this.page.accountMonthList=JSON.parse(this.$route.query.accountMonthList)
    //   this.getTaskList(1);
    // }else{
    //   this.getDefaultMonth()
    // }
  },
  // tofinish
  beforeRouteEnter(to, from, next) {
    // 从其他页面跳转到本页面，重新获取右侧数据
    const refreshPathData = [
      "/surveyExport",
      "/importNewSurveyExport",
      "/surveyFinishList",
      "/importNewFlowTask",
      "/flowTaskFinishList",
      // v26.3.3 从 LS 标注页（labelExecution）返回时刷新：进度/状态由 LS 回调 sync 更新，列表需重查
      "/labelExecution",
    ];
    if (refreshPathData.includes(from.path)) {
      next((vm) => {
        vm.getData();
      });
    } else {
      next();
    }
  },
  mounted() {
    this.getDefaultMonth()
  },
  methods: {
    // 点击导航菜单，页面滚动到指定位置
    handleLeft(item) {
      let self = this;
      const taskStartTime = this.$moment(item.startTime).format("YYYY-MM-DD");
      const taskEndTime =
        new Date().getTime() < new Date(item.endTime).getTime()
          ? this.$moment(new Date()).format("YYYY-MM-DD")
          : this.$moment(item.endTime).format("YYYY-MM-DD");
      this.curTaskItem = {
        ...item,
        taskStartTime,
        taskEndTime,
      };
      self.pageII.pageIndex = 1;
      self.pageII.taskMainGuid = item.guid;
      this.pageII.tenantGuid = item.tenantGuid;
      self.taskTitle = item.isChangeService === 'N' ? item.taskTitleOrganisation :  item.taskTitle;
      self.timeState = item.timeState;
      self.startTime = self.$moment(item.startTime).format('YYYY-MM-DD');
      self.endTime = self.$moment(item.endTime).format('YYYY-MM-DD');
      self.getData();
    },
    getWork(data){
      let list = JSON.parse(data);
      return Array.isArray(list) ? list.join('\n') : list
    },
    //获取任务
    getTaskList(type) {
      if (type) {
        this.page.pageIndex = 1;
      }
      this.page.staffGuid = JSON.parse(localStorage.userInfo).staffGuid;
      let query = JSON.parse(JSON.stringify(this.page));
      let startMonth = query.accountMonthList && query.accountMonthList[0] ? query.accountMonthList[0] : ''
      let endMonth = query.accountMonthList && query.accountMonthList[1] ? query.accountMonthList[1] : ''
      if (startMonth && endMonth) {
        query.startAccountMonth = this.$moment(startMonth).format('YYYYMM')
        query.endAccountMonth = this.$moment(endMonth).format('YYYYMM')
      }
      delete query.accountMonthList
      delete query.accountMonth
      query.isExcludeDataPermission=true;
      // query.years = this.page.years ? [this.page.years] : [];
      this.taskLoading = true;
      this.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/get-list-todo`, query).then((res) => {
        this.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.taskLoading = false;
          if(res.data.data&&res.data.data.records){
            this.taskList = res.data.data.records;
            this.page.totalPage = res.data.data.totalPages;
            this.page.totalRows = res.data.data.totalRows;
          }else{
            this.taskList = [];
            this.page.totalPage = 0;
            this.page.totalRows = 0;
            this.productInformationList=[]//没有任务包的时候，右边列表清空
          }
          if (type && this.taskList.length > 0) {
            this.pageII.taskMainGuid = this.taskList[0].guid;
            this.pageII.tenantGuid = this.taskList[0].tenantGuid;
            this.taskTitle = this.taskList[0].isChangeService === 'N' ? this.taskList[0].taskTitleOrganisation : this.taskList[0].taskTitle;
            this.timeState = this.taskList[0].timeState;
            this.startTime = this.$moment(this.taskList[0].startTime).format('YYYY-MM-DD');
            this.endTime = this.$moment(this.taskList[0].endTime).format('YYYY-MM-DD');
            const taskStartTime = this.$moment(this.taskList[0].startTime).format("YYYY-MM-DD");
            const taskEndTime =
              new Date().getTime() < new Date(this.taskList[0].endTime).getTime()
                ? this.$moment(new Date()).format("YYYY-MM-DD")
                : this.$moment(this.taskList[0].endTime).format("YYYY-MM-DD");
            this.curTaskItem = {
              ...this.taskList[0],
              taskStartTime,
              taskEndTime,
            };
            this.getData()
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
     //年份改变
    yearChange(val){
      this.getTaskList(1);
    },
    //右侧数据
    getData(type) {
      if (type) {
        this.pageII.pageIndex = 1;
      }
      let self = this;
      this.pageII.staffGuid = JSON.parse(localStorage.userInfo).staffGuid;
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/get/staff`, this.pageII).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if(res.data.data.records){
            self.productInformationList = res.data.data.records;
            self.productInformationList.forEach(i=>{
              i.finishRate = i.finishRate == 0?0:Math.floor(i.finishRate*100);
            })
          }else{
            self.productInformationList = [];
          }
          self.pageII.totalPage = res.data.data.totalPages;
          self.pageII.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    // 数据标注行是否只读「查看」（2026-09-28 用户口径）：
    // ①已整包提交（labelSubmitted=ext 阶段离开 LABEL）；②驳回待整改中（labelRectifying=ext.rejected_flag=Y，
    // 整改入口只在待整改列表「去整改」）。两者之外=首次标注（含已保存未提交）→「去完成」可编辑提交。
    // 旧后端无字段时回落旧口径 finishRate>=100（避免提交后误显示「去完成」）
    isSjbzViewOnly(row) {
      if (row.taskContentType != 'SJBZ') return false;
      if (row.labelRectifying === true) return true;
      if (row.labelSubmitted === true) return true;
      if (row.labelSubmitted === false) return false;
      return row.finishRate >= 100;
    },
    toFinish(row, type) {
      const userActive = localStorage.getItem('userActive') == 'true';
      //跳转到 数据标注系统（v26.3.3 二期：页内 micro-app 嵌入标注页；LS 未就绪时新页内回退一期 OAuth 新窗口链路）
      if (row.taskContentType == 'SJBZ') {
        if(!userActive){
          this.$message.error('用户长时间未操作，请重新登录');
          this.$router.push('/login');
          return;
        }
        const query = {
          taskMainGuid: row.taskMainGuid,
          taskDetailGuid: row.taskDetailGuid,
          // 行自带执行人 GUID：label-url 按人定位 item 行（LS 任务），不传则后端回退当前登录人
          staffGuid: row.staffGuid,
          taskTitle: row.taskTitle || row.taskContentName,
        };
        // 已提交/驳回待整改（查看）→ isView=Y 纯只读回看；首次标注不带 → 可继续编辑并点「提交」
        if (this.isSjbzViewOnly(row)) {
          query.isView = 'Y';
        }
        this.$router.push({ path: '/labelExecution', query });
        return;
      }

      if(type&&this.timeState !== '未开始'){//importNewSurveyExport surveyExport
        // this.$router.push('/importNewSurveyExport?productGuid='+this.$route.query.productGuid+'&guid='+row.guid+'&taskDetailGuid='+row.taskDetailGuid);
         let path = row.taskContentType == 'WJDC' ? '/importNewSurveyExport?guid=' : `/importNewFlowTask?taskTitle=${row.taskTitle}&taskContentName=${row.taskContentName}&guid=`;
        this.$router.push(`${path}${row.guid}&taskMainGuid=${row.taskMainGuid}&taskDetailGuid=${row.taskDetailGuid}&tenantGuid=${this.pageII.tenantGuid}`);
      }else if(type&&this.timeState == '未开始'){
        this.$message.error('任务还未开始不可执行')
      }else if(!type){
        let path = row.taskContentType == 'WJDC' ? '/surveyFinishList?guid=' : '/flowTaskFinishList?guid=' ;
        this.$router.push(`${path}${row.guid}&taskMainGuid=${row.taskMainGuid}&taskDetailGuid=${row.taskDetailGuid}&tenantGuid=${this.pageII.tenantGuid}&taskStartTime=${this.curTaskItem.taskStartTime}&taskEndTime=${this.curTaskItem.taskEndTime}`);
        // window.open('/surveyFinishList?guid='+row.guid+'&taskDetailGuid='+row.taskDetailGuid+'&productGuid='+this.$route.query.productGuid)
      }
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getTaskList(true);
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getTaskList(false);
    },

    getSelectItems(list) {
      var str = '';
      if (list && list.length) {
        list.forEach((item, index) => {
          str = str + item.text + '、';
        });
        var reg = /、$/gi;
        str = str.replace(reg, '');
      }
      return str || '-';
    },
    handleSizeChange1(val) {
      let self = this;
      self.pageII.pageSize = val;
      this.getData();
    },
    handleCurrentChange1(val) {
      let self = this;
      self.pageII.pageIndex = val;
      this.getData();
    },
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = val;
    },
    getDefaultMonth() {
      const end = new Date();
      const start = new Date();
      start.setMonth(start.getMonth() - 6);
      this.page.accountMonthList = [start,end]
      this.getTaskList(1);
    }
  },
};
</script>
<style scoped>
/* .icon-management {
  overflow-y: scroll;
  overflow-x: hidden;
} */
.icon-management .top {
  background: #fff;
  text-align: left;
  padding: 10px;
}
.menu-contain {
  display: flex;
  /* 2026-10-08 样式反馈：左右两栏白底连成一体（原两块独立白底在灰底页面上形成分区边框感） */
  background: #fff;
}
.menu {
  width: 300px;
  background: #fff;
  /* 2026-10-10 样式反馈：左右栏之间补回分割线（1px #D9D9D9）——10-08 曾按批注去掉粗灰线 #e5e5e8，
     本轮口径收窄为加回更细更浅的一条；表格仍无边框（10-08 口径维持） */
  border-right: 1px solid #d9d9d9;
}
.menu-item {
  display: flex;
  justify-content: space-between;
  padding: 0 4px;
  align-items: center;
  cursor: pointer;
}
.menu-item .name {
  width: 250px;
  height: 40px;
  line-height: 40px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
/* 新 */
.list-state {
  width: 60px;
  flex-shrink: 0;
}
.list-state span {
  display: inline-block;
  width: 55px;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  text-align: center;
  border-radius: 10px;
}
.list-state .ongoing {
  color: #e59940;
  border: 1px solid #e59940;
  background: rgba(255, 242, 224, 0.09);
}
.list-state .finish {
  color: #4fa1a4;
  background: rgba(100, 159, 163, 0.03);
  border: 1px solid #649fa3;
}
.title {
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 10px;
  background: #fff;
  position: relative;
}
.title span {
  width: 6px;
  height: 14px;
  background: #4fa1a4;
  display: inline-block;
  margin-right: 10px;
}
.pic-list {
  height: auto;
  background: #fff;
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
}
.img-desc {
  width: 168px;
  height: 190px;
}
.pic-list .img {
  margin-left: 20px;
  width: 150px;
  height: 150px;
  background: rgba(0, 0, 0, 0.06);
}
.desc {
  text-align: center;
  margin-bottom: 20px;
  width: 170px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
/deep/ .bread {
  position: fixed;
}
.upload {
  width: 150px;
  height: 150px;
}
/deep/ .el-upload-list--picture-card .el-upload-list__item {
  display: none;
}
.img-desc {
  position: relative;
}
.del-icon {
  position: absolute;
  right: -2px;
  top: 0;
  width: 20px;
  height: 20px;
}
.menu-item .del,
.menu-item .edit {
  display: none;
}
.menu-item:hover .del {
  display: inline;
}
.menu-item:hover .edit {
  display: inline;
}
.menu /deep/ .el-button {
  width: 100%;
}
.menu /deep/ .el-button:focus,
.menu /deep/ .el-button:hover {
  border-color: #4fa1a4;
  color: #4fa1a4;
}
.search-input {
  margin-bottom: 5px;
  width: 100%;
}
.label {
  font-size: 16px;
  background: #fff;
  text-align: left;
  padding-bottom: 20px;
}
.subject-table {
  flex: 1;
  width: calc(100% - 300px);
  background: #fff;
  padding: 12px;
  box-sizing: border-box;
}
/* 2026-10-10 用户要求：右栏表格对齐 labelAuditList（系统列表 .content-main-box 标准）风格——
   12px/#212121/32px 行高/表头 #F2F2F2 + #D9D9D9 边线/斑马纹。按 10-08 批次B 先例 scoped 复刻整套规则，
   不直接套 .content-main-box 类（该类自带固定高度+overflow-y，会破坏本页双栏布局） */
.subject-table /deep/ .el-table {
  font-size: 12px;
  color: #212121;
}
.subject-table /deep/ .el-table__body-wrapper tr,
.subject-table /deep/ .el-table__body td.el-table__cell {
  height: 32px;
}
.subject-table /deep/ .el-table .el-table__cell {
  padding: 0px;
}
.subject-table /deep/ .el-table th.el-table__cell {
  background-color: #f2f2f2;
  height: 32px;
  border-right: 1px solid #d9d9d9;
  border-top: 1px solid #d9d9d9;
  /* 10-10 反馈明确表头不加粗（labelAuditList 走 Element 默认 500，此处按反馈口径 400） */
  font-weight: 400;
}
.subject-table /deep/ .el-table th.el-table__cell:last-child {
  border-right: none;
}
.subject-table /deep/ .el-table th.el-table__cell:nth-last-child(2) {
  border-right: none;
}
.subject-table /deep/ .el-table td.el-table__cell,
.subject-table /deep/ .el-table th.el-table__cell.is-leaf {
  border-bottom: 1px solid #d9d9d9;
}
/* 与 labelAuditList 的唯一刻意差异：外框维持去除（2026-10-10 用户拍板"外框不加回"）。
   若要连外框也一致，删掉下面两段覆盖即可（labelAuditList 的表是带外框的） */
.subject-table /deep/ .el-table--border,
.subject-table /deep/ .el-table--group {
  border: none;
}
.subject-table /deep/ .el-table--border::after {
  width: 0;
}
.top-title {
  font-size: 18px;
  text-align: left;
  margin: 2px 0 12px 0;
}
.subject-table-title {
  display: flex;
  justify-content: space-between;
  text-align: left;
  font-size: 18px;
  color: #323233;
  margin-top: 0;
}
.subject-table-title span{
  font-size: 14px;
  color:  #5D5D5D;
}
.table-progress {
  display: flex;
  align-items: center;
  justify-content: center;
}
.table-progress span {
  margin-left: 5px;
}
.no-task{
  text-align: center;
  color: rgb(165, 161, 161);
}
.year-select{
  /* width: 110px; */
  /* flex-shrink: 0; */
  margin-left: 5px;
}
</style>